import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './page/login';
import LoginSp from './page/loginSp';
import LoginOidc from './page/loginOidc';
import LoginContinue from './page/continue';
import SetCookie from './page/setcookie';
import FeiShuCallback from './page/callback/feishu';
import DdCallback from './page/callback/dd';
import FeiShuCodeCallback from './page/callback/feishuCode';
import Error from './page/error';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/continue" element={<LoginContinue />} />
        <Route path="/login/sp/:type" element={<LoginSp />} />
        <Route path="/oidc_login" element={<LoginOidc />} />
        <Route path="/login/setCookie" element={<SetCookie />} />
        <Route path="/callback/feishu" element={<FeiShuCallback />} />
        <Route path="/callback/dd" element={<DdCallback />} />
        <Route path="/callback/feishuCode" element={<FeiShuCodeCallback />} />
        <Route path="/*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;